import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { GeneralConstants } from '../constants/GeneralConstants';
import { Observable, Subject, throwError } from 'rxjs';
import { start } from '@popperjs/core';

const devUrl = environment.backendurl

@Injectable({
    providedIn: 'root'
})

export class AiSourcingService {
    constructor(private http: HttpClient, private router: Router) { }

  private selectCandidateObservable: Subject<any> = new Subject();
  private candidateObservable: Subject<any> = new Subject();
  private insightsAiObservable: Subject<any> = new Subject();
  private refreshListObservable: Subject<any> = new Subject();
  private candidateListObservable: Subject<any> = new Subject();
  private projectDetailsObservable: Subject<any> = new Subject();

  /**
   * Method to get the select all candidate event.
   * This method returns an observable that emits the candidate data when the select all event is triggered.
   */
  get getSelectAllCandidateEvent(): Observable<any> {
    return this.selectCandidateObservable.asObservable();
  }

  /**
   * Method to emit the select all candidate event.
   * @param candidateData - The data of the candidate to be emitted.
   */
  emitSelectAllCandidateEvent(candidateData: any) {
    this.selectCandidateObservable.next(candidateData);
  }

  get getCandidateEvent(): Observable<any> {
    return this.candidateObservable.asObservable();
  }

emitCandidateEvent(candidateData: any) {
    this.candidateObservable.next(candidateData);
  }

  get getInsightsAiEvent(): Observable<any> {
    return this.insightsAiObservable.asObservable();
  }

  emitInsightsAiEvent(aiData: any) {
    this.insightsAiObservable.next(aiData);
  }

  get getRefreshListEvent(): Observable<any> {
    return this.refreshListObservable.asObservable();
  }

  emitRefreshListEvent(data: any) {
    this.refreshListObservable.next(data);
  }

  get getCandidateListEvent(): Observable<any> {
    return this.candidateListObservable.asObservable();
  }

  emitCandidateListEvent(data: any) {
    this.candidateListObservable.next(data);
  }

  get getProjectDetailsEvent(): Observable<any> {
    return this.projectDetailsObservable.asObservable();
  }

  emitProjectDetailsEvent(data: any) {
    this.projectDetailsObservable.next(data);
  }

  /**
   * Method to fetch the project list.
   */
  getProjectList(startindex: Number, limit: Number, projectname?: string | null, SortByUpdatedon?: string, SortByProjectName?: string, sortbypipelinecount?: string, projectstatus?: string | null): Observable<any> {
    const url = devUrl + '/aisourcing/projects/list';
    let params = new HttpParams();

    if (SortByUpdatedon && SortByUpdatedon?.trim()) {
      params = params.set('updatedon', SortByUpdatedon.trim());
    }
    if (SortByProjectName && SortByProjectName?.trim()) {
      params = params.set('sortbyprojectname', SortByProjectName.trim());
    };
    if (sortbypipelinecount && sortbypipelinecount?.trim()) {
      params = params.set('sortbypipelinecount', sortbypipelinecount.trim());
    }


    if (projectname && projectname?.trim()) {
      params = params.set('projectname', projectname.trim());
    }

    if (startindex !== undefined && limit !== undefined) {
      params = params
        .set('startindex', startindex.toString())
        .set('limit', limit.toString());
    };

    if (projectstatus && projectstatus?.trim()) {
      params = params.set('projectstatus', projectstatus.trim());
    }

    return this.http.get<any>(url, { params }).pipe(
      map(response => ({ ...response, statusCode: response.status })),
      catchError((err: HttpErrorResponse) => throwError(err))
    );
  };

    /**
     * Method to use fetch project details
     * @param projectnumber
     */
    getProjectDetails(projectnumber: string) {
        const url = devUrl + `/aisourcing/project/${projectnumber}`;
        return this.http.get<any>(url).pipe(
            map(response => ({ ...response, statusCode: response.status }))
            , catchError(GlobalService.handleError('Get Project Details ', url)))
    };


    /**
     * Method to create a new project.
     * @param projectName
     * @param jobDescription
     */
    createProject(data: any) {
      const url = devUrl + '/aisourcing/project';
      return this.http.post<any>(url, data, { observe: 'response' }).pipe(
        map(response => ({ ...response, statusCode: response.status }))
        , catchError((err: HttpErrorResponse) => throwError(err)))
    };


    /**
     * Method to rename a project.
     * @param projectnumber
     * @param projectname
     */
    renameProject(projectnumber: string, projectname: any) {
        const url = devUrl + `/aisourcing/project/${projectnumber}`;
      return this.http.patch<any>(url, projectname, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
        , catchError((err: HttpErrorResponse) => throwError(err)));
    };


    /**
     * Method to check if the project name already exists.
     * @param projectName
     * @returns
     */

    isDuplicateProjectName(projectName: string) {
        const url = devUrl + '/aisourcing/project/name/duplicate';
        const params = new HttpParams().set('projectname', projectName)
        return this.http.get(url, { params }).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('Get duplicate project name', url)))
    };

    /**
     * Method to use Update Evaluation Criteria
     * @param data
     * @returns
     */
    updateScreeningCriteria(criteia: any, projectnumber: string) {
      const url = devUrl + `/aisourcing/project/evaluationcriteria/${projectnumber}`;
      return this.http.put<any>(url, criteia, { observe: 'response' }).pipe(map((response) => ({ ...response, statusCode: response.status })),
        catchError((err: HttpErrorResponse) => throwError(err)));
    };

    /**
     * Method to use fetch Suggested Evaluation Criteria
     * @param projectnumber
     */
    getSuggestedEvaluationCriteria(projectnumber: string) {
        const url = devUrl + `/aisourcing/project/suggestedcriteria/${projectnumber}`;
        return this.http.get(url).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('Get Project Evaluation Suggested Criteria ', url)))
    };


    /**
    * Method to use fetch Project Evaluation Criteria
    * @param projectnumber
    */
    getProjectEvaluationCriteria(projectnumber: string) {
        const url = devUrl + `/aisourcing/project/evaluationcriteria/${projectnumber}`;
        return this.http.get(url).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('Get Project Evaluation Criteria ', url)))
    };

    /**
     * Methods to use parse jobdescription to grok
     * @param description
     * @returns
     */
    jdJSONDetails(description = null) {
        const formData = new FormData();
        formData.append("description", description);
        const url = devUrl + "/personsearch/jobdescription";
        return this.http.post(url, formData).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch JSON params for Job Description: ', url)));
    };


    /**
     * Method to request wait list
     * @param data
     * @returns
     */
    get isAISourcingTab() {
        const url = this.router.url;
        return (url?.startsWith("/ai-sourcing"));
    }

    /**
    * Check is resume screen tab
    */
    get isResumeScreenTab() {
      const url = this.router.url;
      return (url?.startsWith("/resume-screen"));
    };

    get isAISourcingInsightsTab() {
        const url = this.router.url;
        return (url?.startsWith("/ai-sourcing/ai-sourcing-insights"));
    }


    get isAISourcingprojectNumber() {
        const url = this.router.url;
        const projectNumber = url?.split('/')[4];
        return projectNumber;
    }



    /**
     * Method to request wait list
     * @param data
     * @returns
     */
    joinWaitlistRequested(data: any) {
        const url = devUrl + `/users/aisourcingwaitlist`;
        return this.http.patch(url, data).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('Request join waitlist', url)))

    };


    /**
     * Method to fetch all the candidate list
     * @param data
     */
    getCandidateList(data: any, projectnumber: string) {
          const url = devUrl + `/aisourcing/project/${projectnumber}/candidatelist`;
          return this.http.post<any>(url, data).pipe(
             map((response) => ({ ...response, statusCode: response.status }))
              , catchError(GlobalService.handleError('Get all candidate', url)))
    };

    /**
     * Method to change candidate status
     * @param data
     */

    changeCandidateStatus(data: any = {}) {
        const url = devUrl + `/aisourcing/candidate/status`;
        return this.http.patch<any>(url, { ...data }).pipe(
            map(response => ({ ...response, statusCode: response.status }))
            , catchError(GlobalService.handleError('Change candidate status', url)))
    }

    /**
     * Method to fetch project activity
     * @param data
     */
    getprojectActivity(projectnumber: string) {
        const url = devUrl + `/aisourcing/project/activity/${projectnumber}`;
        return this.http.get(url).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('Get Project Activity', url)))
    };

    /**
     * Method to fetch archived reasons
     * @returns
     */

    getArchivedReasons() {
      const url = devUrl + `/aisourcing/project/archivedreasons`;
        return this.http.get(url).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('Get Archived Reasons', url)))

    }

    getMoreCandidates(projectnumber: string) {
      const url = devUrl + `/aisourcing/project/${projectnumber}/morecandidate`;
      return this.http.get<any>(url).pipe(
             map((response) => ({ ...response, statusCode: response.status }))
          , catchError(GlobalService.handleError('Get More Candidates', url)))
    }

    reevaluateCriteria(data:any) {
      const url = devUrl + `/aisourcing/project/reevaluate`;
      return this.http.post(url, data).pipe(
          map(response => { return response; })
          , catchError(GlobalService.handleError('Re-evaluate Criteria', url)))
    }

    contactReveal(projectnumber: string, elasticId: string) {
      const url = devUrl + `/aisourcing/project/${projectnumber}/candidate/${elasticId}/contactdetails`;
      return this.http.get(url).pipe(
          map(response => { return response; })
          , catchError(GlobalService.handleError('Contact Reveal', url)))
    }

    getTotalAISourcingAggs(projectnumber, requestobject):  Observable<any> {
        const url = devUrl + `/aisourcing/project/${projectnumber}/aggregates`;
        return this.http.post<any>(url, requestobject).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('Get Person Search Listing', url)));
      }

  /**
   * Method to use get filter aggregate
   * @param projectnumber
   * @param requestobject
   * @returns
   */
  getAISourcingFilterAgg(projectnumber: string, requestobject: any): Observable<any> {
    const url = devUrl + `/aisourcing/project/${projectnumber}/candidatelistaggregates`;
    return this.http.post<any>(url, requestobject).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  };

  /**
   * Method to track AI sourcing email campaign activity
   * @param payload
   * @returns
   */
  aiSourcingEmailCampaignActivity(payload:any): Observable<any> {
        const url = devUrl + `/aisourcing/project/activity`;
    return this.http.post<any>(url, payload).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('AI Sourcing Activity', url)));

  }


    /**
   * Method to track AI sourcing Migration
   * @param payload
   * @returns
   */
  aiSourcingMigrate(payload:any): Observable<any> {
        const url = devUrl + `/aisourcing/migrate`;
    return this.http.post<any>(url, payload).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('AI Sourcing migrate', url)));

  }

/**
 * Method to track AI sourcing migration progress
 * @param payload - object containing the project number and the job description
 * @returns - Observable containing the response from the server
 */
  getAiSourcingProgress(payload:{projectnumber: string, type: string}): Observable<any> {
    const url = devUrl + `/aisourcing/project/status`;
    return this.http.post<any>(url, payload).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('AI Sourcing migrate', url)));
  };

  /**
 * Method to get Autopilot access
 * @param payload - object containing the loginemail and aautopilotslotaccess
 * @returns - Observable containing the response from the server
 */
  getAutopilotaccess(payload): Observable<any> {
    const url = devUrl + `/autopilotaccess`;
    return this.http.patch<any>(url, payload).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Autopilot Access', url)));
  };

   /**
 * Method to change project status
 * @param payload - object containing the project number and the new status
 * @returns - Observable containing the response from the server
 */

  changeProjectStatus(payload: any): Observable<any> {
       const url = devUrl + `/aisourcing/project/activationstatus`;
    return this.http.patch<any>(url, payload).pipe(map((response) => ({ ...response, statusCode: response.status }))
     , catchError(GlobalService.handleError('change project status', url)));
  }

  /**
   * Method to get Autopilot Users
   * @param projectnumber - The project number for which to fetch the Autopilot users
   * @returns - Observable containing the response from the server
   */

  getAutopilotUsers(projectnumber: string): Observable<any> {
    const url = devUrl + `/aisourcing/share/list/${projectnumber}`;
    return this.http.get<any>(url).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Autopilot Users', url)));
  }
  /**
   * Method to share project with team members
   * @param payload - object containing the project number and the list of users to share the project with
   * @returns - Observable containing the response from the server
   */

  shareProject(payload: any): Observable<any> {
    const url = devUrl + `/aisourcing/project/share`;
    return this.http.post<any>(url, payload).pipe(map((response) => ({ ...response, statusCode: response.status }))
     , catchError(GlobalService.handleError('Share Project', url)));
  }

  notifyAdmin(payload: any): Observable<any> {
    const url = devUrl + `/aisourcing/notify/project`;
    return this.http.post<any>(url, payload).pipe(map((response) => ({ ...response, statusCode: response.status }))
     , catchError(GlobalService.handleError('Notify Admin', url)));
  }

  /**
   * Bulk export of candidates and project details in excel format
   * @param payload
   * @returns
   */
  bulkExport(payload: { projectnumber: string, elasticids: string[] }): Observable<any> {
    const url = devUrl + `/aisourcing/bulk-export`;
    return this.http.post<any>(url, payload, { observe: 'response' }).pipe(map((response) => ({ ...response, statusCode: response.status }))
      , catchError((err: HttpErrorResponse) => throwError(err)));
  }

  /**
   * Method to check candidate count when project details are updated
   * @param data
   * @param projectnumber - The project number for which to check the candidate count
   * @returns
   */
  modifyProject(data: any, projectnumber: string) {
    const url = devUrl + `/aisourcing/projectdetails/${projectnumber}`;
    return this.http.patch<any>(url, data, { observe: 'response' }).pipe(
      map(response => ({ ...response, statusCode: response.status }))
      , catchError((err: HttpErrorResponse) => throwError(err)))
  };

  /**
   * Method to revise suggested criteria for a project
   * @param data
   * @returns
   */
  editableProjectCriteria(data: any) {
    const url = devUrl + `/aisourcing/suggestedcriteria/revise`;
    return this.http.post<any>(url, data, { observe: 'response' }).pipe(
      map(response => ({ ...response, statusCode: response.status }))
      , catchError((err: HttpErrorResponse) => throwError(err)))
  };

  /**
   * Method to revise suggested criteria for a project
   * @param data
   * @returns
   */
  startProjectWithUpdatedDetails(data: any) {
    const url = devUrl + `/aisourcing/project/start`;
    return this.http.post<any>(url, data, { observe: 'response' }).pipe(
      map(response => ({ ...response, statusCode: response.status }))
      , catchError((err: HttpErrorResponse) => throwError(err)))
  };

}
